import {useMemo} from 'react'
import {graphql, useSubscription} from 'react-relay'

import type {PullRequestRowSubscription} from './__generated__/PullRequestRowSubscription.graphql'

// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-queries
const subscription = graphql`
  subscription PullRequestRowSubscription($pullRequestId: ID!) {
    pullRequestInfoForListViewUpdated(id: $pullRequestId) {
      titleUpdated {
        title
        titleHTML
      }
      statusUpdated {
        state
        isDraft
      }
      commentsUpdated {
        ...PullRequestItemMetadata
      }
      reviewDecisionUpdated {
        ...IssuePullRequestDescription
      }
      commitChecksUpdated {
        ...CheckRunStatusFromPullRequest
      }
    }
  }
`

const usePullRequestRowSubscription = (pullRequestId: string) => {
  const config = useMemo(() => {
    return {
      subscription,
      variables: {pullRequestId},
    }
  }, [pullRequestId])

  useSubscription<PullRequestRowSubscription>(config)
}

export function PullRequestRowSubscriber({pullRequestId}: {pullRequestId: string}) {
  usePullRequestRowSubscription(pullRequestId)
  return null
}
